var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcFireTitle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic \xC2\xB7 fire"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.6415 1.3248C10.5683 1.26395 10.4815 1.22159 10.3885 1.20128C10.2955 1.18098 10.199 1.18333 10.1071 1.20815C10.0152 1.23296 9.93065 1.2795 9.86051 1.34385C9.79037 1.4082 9.73672 1.48847 9.7041 1.57789L8.07129 6.06145L6.27816 4.32398C6.21794 4.26558 6.14603 4.22059 6.06717 4.192C5.9883 4.16341 5.90427 4.15185 5.82061 4.15809C5.73695 4.16433 5.65556 4.18823 5.58181 4.22821C5.50806 4.26819 5.44362 4.32334 5.39273 4.39004C3.78516 6.49637 2.96875 8.61531 2.96875 10.6875C2.96875 12.4197 3.65686 14.0809 4.88171 15.3058C6.10656 16.5306 7.7678 17.2188 9.5 17.2188C11.2322 17.2188 12.8934 16.5306 14.1183 15.3058C15.3431 14.0809 16.0312 12.4197 16.0312 10.6875C16.0312 6.2752 12.2617 2.67187 10.6415 1.3248ZM13.6481 11.3807C13.4941 12.2407 13.0804 13.0328 12.4625 13.6505C11.8447 14.2682 11.0525 14.6818 10.1925 14.8356C10.1599 14.8412 10.1268 14.8439 10.0938 14.8438C9.94481 14.8437 9.80133 14.7877 9.69176 14.6868C9.58218 14.586 9.51452 14.4476 9.50219 14.2992C9.48986 14.1507 9.53376 14.0031 9.62519 13.8855C9.71662 13.7679 9.84889 13.689 9.99578 13.6644C11.2256 13.4573 12.2691 12.4138 12.4777 11.1818C12.504 11.0265 12.591 10.888 12.7195 10.7969C12.848 10.7057 13.0074 10.6693 13.1627 10.6957C13.318 10.722 13.4565 10.809 13.5476 10.9375C13.6388 11.066 13.6752 11.2254 13.6488 11.3807H13.6481Z",
    fill: "#FB923C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFireTitle);
export default __webpack_public_path__ + "static/media/ic-fire-title.a9e9f6a48468bee6b2834973cf72bf50.svg";
export { ForwardRef as ReactComponent };